import { BaseService } from '@common-modules/shared/base.service';
import { Observable } from 'rxjs';
import { DynamicSettings } from './models/dynamic-settings';
import { DynamicSettingsDelete } from './models/dynamic-settings-delete';
import { DynamicSettingsSave } from './models/dynamic-settings-save';

export abstract class PersistSettingsService extends BaseService {
  abstract load(settings: DynamicSettings): Observable<any>;
  abstract save(settings: DynamicSettingsSave): Observable<any>;
  abstract delete(settings: DynamicSettingsDelete): Observable<any>;
}
